module.exports = __webpack_public_path__ + "img/29_37.34f7fd15.png";